import React, { Component } from "react";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import Loader from "../components/utility/loader";

const importCache = new Map();

function loadImport(importComponent) {
  let entry = importCache.get(importComponent);
  if (entry) {
    return entry;
  }
  entry = {
    status: "pending",
    Component: null,
    promise: importComponent()
      .then((mod) => {
        const Component = mod && mod.default;
        if (!Component) {
          throw new Error("Async route is missing a default export");
        }
        entry.status = "ready";
        entry.Component = Component;
        return entry;
      })
      .catch((error) => {
        importCache.delete(importComponent);
        throw error;
      }),
  };
  importCache.set(importComponent, entry);
  return entry;
}

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      const entry = loadImport(importComponent);
      this.state = {
        Component: entry.status === "ready" ? entry.Component : null,
        hasError: false,
      };
    }

    componentDidMount() {
      this.mounted = true;
      if (this.state.Component) {
        return;
      }
      Nprogress.start();
      loadImport(importComponent)
        .promise.then((entry) => {
          Nprogress.done();
          if (this.mounted) {
            this.setState({
              Component: entry.Component,
              hasError: false,
            });
          }
        })
        .catch(() => {
          Nprogress.done();
          if (this.mounted) {
            this.setState({ hasError: true });
          }
        });
    }

    componentWillUnmount() {
      this.mounted = false;
      Nprogress.done();
    }

    render() {
      const { Component, hasError } = this.state;

      if (hasError) {
        return (
          <div
            style={{
              minHeight: 240,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 24,
              color: "#595959",
            }}
          >
            This page failed to load. Please refresh and try again.
          </div>
        );
      }

      if (!Component) {
        return (
          <div
            className="async-route-loader"
            style={{ position: "relative", minHeight: 280 }}
          >
            <Loader />
          </div>
        );
      }

      return <Component {...this.props} />;
    }
  }

  return AsyncFunc;
}
